import api from './api';
import { SearchFilters, SearchResponse, SpeciesOptionsResponse } from '../types';

const normalizeFilters = (filters: SearchFilters): Record<string, string | number> => {
  const params: Record<string, string | number> = {};

  Object.entries(filters).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') {
      return;
    }
    params[key] = value;
  });

  return params;
};

export const searchService = {
  async search(filters: SearchFilters): Promise<SearchResponse> {
    const response = await api.get<SearchResponse>('/analytics/search', {
      timeout: 90000,
      params: normalizeFilters(filters),
    });

    return response.data;
  },

  async getSpeciesOptions(limit = 200): Promise<SpeciesOptionsResponse> {
    const response = await api.get<SpeciesOptionsResponse>('/analytics/species-options', {
      params: { limit },
      timeout: 30000,
    });

    return response.data;
  },
};
